import React, { useState, useEffect } from "react";
import "../../assets/styles/styleUser.css";
import { toast } from "react-toastify";
import AuthService from "../../services/AuthServices";
import MyBookingsDesign from "../../components/myBookingDesign";
import { lineSpinner } from "ldrs";
import { colors } from "../../assets/config/color";

function MyBookings({ searchBook }) {
  lineSpinner.register();
  const [userId, setUserId] = useState();
  const [token, setToken] = useState();
  const [orders, setOrders] = useState([]);
  const [filteredOrder, setfilteredOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const[employees,setEmployees]=useState([]);
  const [types,setTypes]=useState([]);
  const getUserData = () => {
    const tok = localStorage.getItem("token");
    const id = localStorage.getItem("id");
    setUserId(id);
    if (tok) {
      setToken(tok);
    } else {
      window.location.replace("/");
    }
  };
  const fetchData = async (fetchFunction, successCallback, errorMessage) => {
    try {
      if (token && userId) {
        const response = await fetchFunction(userId, token);
        if (response.data) {
          successCallback(response.data);
        } else {
          toast.error(response.error);
        }
      } 
    } catch (error) {
      toast.error(errorMessage);
    } 
  };
  const handleCategories = () =>
  fetchData(AuthService.getBraidsCategories, setCategories, "Failed to fetch categories.");
  const handleTypes = () =>
  fetchData(AuthService.getAllTypes, setTypes, "Failed to fetch types.");
  const handleOrders = async () => {
    setIsLoading(true);
    try {
      const response = await AuthService.getOrders(token);
      if (response.data) {
        const userOrders = response.data.filter(order => order.client_id === parseInt(userId));
      const ordersWithEmployeeName = userOrders.map(order => {
        const employee = employees.find(emp => emp.id === order.employer_id);
        return {
          ...order,
          employee_name: employee ? `${employee.firstName} ${employee.lastName}` : "Unknown",  // Ajout du nom de l'employé
        };
      });

      setOrders(ordersWithEmployeeName);
        toast.success(response.message);
        } else {
          toast.error(response.error);
          }
    }
    catch (error) {
      toast.error("Failed to fetch orders");
      }
      finally {
        setIsLoading(false);
      }
  }
  const handleEmployer = async () =>{
      try {
        const response = await AuthService.getAllEmployer(token);
        if (response.data) {
          setEmployees(response.data);
          toast.success(response.message);
          } else {
            toast.error(response.error);
            }
      }
      catch (error) {
        toast.error("Failed to fetch employer");
        }
  }

 
  useEffect(() => {
    getUserData();
  }, []);
  useEffect(() => {
    if (userId && token) {
      handleCategories();
      handleTypes();
      handleEmployer();
    }
  }, [userId, token]);
  useEffect(() => {
    if (employees.length > 0) {
      handleOrders();
    }
  }, [employees, userId, token]);

  const applyFilters = () => {
    let filtered = orders;

    if (searchBook.trim() !== "") {
      filtered = filtered.filter(
        (order) =>
          order.braid_name.toLowerCase().includes(searchBook.toLowerCase()) ||
          order.place_name.toLowerCase().includes(searchBook.toLowerCase()) ||
          order.order_status.toLowerCase().includes(searchBook.toLowerCase())
      );
    }

    setfilteredOrder(filtered);
  };
  useEffect(() => {
    applyFilters();
  }, [searchBook, orders]);

  return (
    <div className="main-contentH">
      <div className="main-content">
        <div className="padding">
          <div className="lstBook">List of my bookings</div>
          {isLoading ? (
            <div className="spinner">
              <l-line-spinner size="50" color={colors.gold}></l-line-spinner>
            </div>
          ) : (
            <>
              <div className="rowM" style={{ width: "100%" }}>
                <MyBookingsDesign mybooking={filteredOrder} allTypes={types} categories={categories} employeeAll={employees} />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MyBookings;
